window.$ = window.JQuery = require('jquery');
window.Flickity = require('flickity');

import Alpine from 'alpinejs'
import dialog from '@fylgja/alpinejs-dialog';

import './scroll';
import circular from './components/circular';
import resultsandreports from './components/resultsandreports';
import announcements from './components/announcements';
import accordion from './components/accordion';
import table from './components/table';


import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

window.Alpine = Alpine;

Alpine.plugin(dialog);

document.addEventListener('alpine:init', () => {
    Alpine.data('circular', circular);
    Alpine.data('resultsandreports', resultsandreports);
    Alpine.data('announcements', announcements);
    Alpine.data('accordion', accordion);
    Alpine.data('table', table);
});

Alpine.start();

Flickity.prototype.manageFocus = function() {
    this.cells.forEach((cell, index) => {

        const isSelected = index === this.selectedIndex;
        const focusableElements = cell.element.querySelectorAll(
        'a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])'
        );
        
        focusableElements.forEach(el => {
            el.tabIndex = isSelected ? 0 : -1;
        });
    });
};

$(document).ready(function() {

    if ($('.article-carousel-wrapper').length > 0) {
        var articles = new Flickity(document.querySelector('.article-carousel-wrapper'), {
            on: {
                ready: function() {
                    this.manageFocus();
                },
                change: function() {
                    this.manageFocus();
                }
            },
            cellAlign: 'center',
            contain: true,
            adaptiveHeight: false,
            pageDots: false,
            pauseAutoPlayOnHover: false,
            arrowShape: "m4.55,45.21c-2.65,2.65-2.65,6.95,0,9.59l33.88,33.88c2.65,2.65,6.95,2.65,9.59,0,2.65-2.65,2.65-6.95,0-9.59l-22.34-22.32h64.97c3.75,0,6.78-3.03,6.78-6.78s-3.03-6.78-6.78-6.78H25.71l22.3-22.32c2.65-2.65,2.65-6.95,0-9.59s-6.95-2.65-9.59,0L4.53,45.19l.02.02Z"
        });

        

        



        var carouselWrapper = document.querySelector('.article-carousel-wrapper');

        var progressBarWrapper = document.createElement('div');
        progressBarWrapper.className = 'article-progress-bar-wrapper';

        var progressBar = document.createElement('div');
        progressBar.className = 'article-progress-bar';

        progressBarWrapper.appendChild(progressBar);


        carouselWrapper.appendChild(progressBarWrapper);

        var progressBar = document.querySelector('.article-progress-bar');

        articles.on( 'scroll', function( progress ) {
            progress = Math.max( 0, Math.min( 1, progress ) );
            progressBar.style.width = progress * 100 + '%';
        });
    }


    

    if ($('.logo-carousel-wrapper').length > 0) {
        var $carousel = $('.logo-carousel-wrapper');
        
        var flkty = new Flickity($carousel[0], {
            cellAlign: 'center',
            contain: true,
            autoPlay: 5000,
            adaptiveHeight: false,
            pageDots: true,
            pauseAutoPlayOnHover: false,
            groupCells: true
        });
        
        updateNavVisibility($carousel);
 
        
        window.addEventListener('resize', function() {
            updateNavVisibility($carousel);
        });
        

        flkty.on('settle', function() {
            updateNavVisibility($carousel);
        });
        
        flkty.on('ready', function() {
            updateNavVisibility($carousel);
        });
    }


    if ($('.jstable').length > 0) {
        new Flickity(document.querySelector('.jstable'), {
            // cellAlign: 'center',
            setGallerySize: true,
            contain: true,
            autoPlay: 5000,
            adaptiveHeight: false,
            pageDots: true,
            pauseAutoPlayOnHover: false,
            groupCells: true
        });
    }

    //results page
    if ($('.results').length > 0) {
        ScrollTrigger.create({
            trigger: '.results',
            start: 'top center',
            end: 'bottom center',
            onEnter: counter,
          });
    }

    //results page
    if ($('.stats').length > 0) {
        ScrollTrigger.create({
            trigger: '.stats',
            start: 'top center',
            end: 'bottom center',
            onEnter: counter,
          });
    }

    //enable scrolling on cookie consent
    document.addEventListener("cookieyes_consent_update", function (eventData) 
    {
        const preferenceWrapper = document.querySelector('.cky-preference-body-wrapper');
        if (preferenceWrapper) {
            preferenceWrapper.setAttribute('data-lenis-prevent-wheel', '');
        }
    });

});


function updateNavVisibility($carousel) {
    var navButtons = $carousel.find('.flickity-button');
    var pageDots = $carousel.find('.flickity-page-dots');
    var totalCells = $carousel.find('.carousel-cell').length;
    var visibleCells = $carousel.find('.carousel-cell.is-selected').length;
    var isNavNeeded = totalCells > visibleCells;
    navButtons.css('display', isNavNeeded ? '' : 'none');
    pageDots.css('display', isNavNeeded ? '' : 'none');
}


function counter () {

    const elements = document.querySelectorAll('.results__value');

    elements.forEach((element) => {
    const targetValue = parseFloat(element.textContent);
    element.textContent = 0;

    gsap.to(
        element,
        {
            textContent: targetValue.toFixed(1),
            duration: 1.4,
            ease: "power1.in",
            onUpdate: function () {
                const roundedValue = parseFloat(element.textContent).toFixed(1);
                element.innerHTML = customRound(parseFloat(roundedValue));
            },
            }
        );
    });
}

function customRound(number) {
    if (Number.isInteger(number)) {
        return number;
    } else {
        return number.toFixed(1);
    }
}